import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar/NavBar";
import Footer from "./Footer/Footer";
import FloatingContactButton from "components/FloatingContactButton";

const Layout = () => {
  return (
    <div className="public-layout">
      <NavBar />
      <main>
        <Outlet />
      </main>
      <FloatingContactButton />
      <Footer />
    </div>
  );
};

export default Layout;
